module.exports = __webpack_public_path__ + "static/media/icon_admin_info.d05194d4.svg";